import React, { useEffect, useState } from "react";
import PurchasedPlotsPopup from "./PurchasedPlots.Popup";
import Backdrop from "@mui/material/Backdrop";
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  Modal,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { colors, fonts, size } from "../../ColorFont/color";
import {
  CardMembership,
  Edit,
  Visibility,
} from "@mui/icons-material";
import { url } from "../../ConstUrl/Url";
import PlanPurchaseHistoryModal from "./PlanPurchaseHistoryModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ListBuyers = (userData) => {
  const userId = userData?._id;
  const [buyers, setBuyers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const [newNoOfContacts, setNewNoOfContacts] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedBuyerId, setSelectedBuyerId] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [openplans, setOpenplans] = useState(false);
  const [planPurchaseHistory, setPlanPurchaseHistory] = useState([]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const fetchBuyers = async () => {
      try {
        const response = await fetch(`${url}/api/users/buyer`);
        if (!response.ok) {
          throw new Error("Failed to fetch buyers");
        }
        const data = await response.json();
        setBuyers(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBuyers();
  }, []);

  const handleViewPurchasedPlans = async (userId) => {
    try {
      const response = await fetch(
        `${url}/api/users/${userId}/plan-purchase-history`
      );
      const data = await response.json();
      setPlanPurchaseHistory(data.planPurchaseHistory);
      setOpenplans(true);
      setSelectedBuyerId(userId);
    } catch (error) {
    }
  };

  if (loading) {
    return (
      <>
        <Box sx={{ margin: "20px" }}>
          <Skeleton
            variant="rectangular"
            sx={{ width: 300, height: 40, marginBottom: 5 }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              flexWrap: "wrap",
            }}
          >
            <Box
              sx={{
                width: "28%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Paper
                elevation={4}
                sx={{
                  padding: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Skeleton variant="circular" sx={{ width: 50, height: 50 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              </Paper>

              <Paper
                elevation={4}
                sx={{
                  padding: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Skeleton variant="circular" sx={{ width: 50, height: 50 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              </Paper>

              <Paper
                elevation={4}
                sx={{
                  padding: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Skeleton variant="circular" sx={{ width: 50, height: 50 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
                <Skeleton variant="text" sx={{ width: 200, height: 40 }} />
              </Paper>
            </Box>
          </Box>
        </Box>
      </>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleEditBuyer = (buyer) => {
    setSelectedBuyer(buyer);
    setIsOpen(true);
  };

  const handleUpdateNoOfContacts = async () => {
    try {
      const response = await fetch(`${url}/api/users/${selectedBuyer._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ noOfContacts: parseInt(newNoOfContacts) }),
      });
      if (response.ok) {
        setBuyers(
          buyers.map((b) =>
            b._id === selectedBuyer._id
              ? { ...b, noOfContacts: parseInt(newNoOfContacts) }
              : b
          )
        );
        setIsOpen(false);
      } else {
        console.error("Error updating No Of Contacts");
      }
    } catch (error) {
      console.error("Error updating No Of Contacts:", error);
    }
  };

  const handleViewPurchasedPlots = (userId) => {
    handleOpen();
    setIsPopupOpen(true);
    setSelectedBuyerId(userId);
  };

  return (
    <Box>
      <Box sx={{ margin: "14px" }}>
        <Typography
          sx={{
            fontFamily: fonts.poppins,
            fontWeight: 600,
            fontSize: 24,
            color: colors.primary_dark,
            marginBottom: 4,
          }}
        >
          Buyer Lists
        </Typography>

        {buyers.length > 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <TableContainer
              component={Paper}
              elevation={0}
              sx={{ 
                borderRadius: 3, 
                border: `1px solid ${colors.border}`,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)"
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Profile
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Email
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Contact
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Address
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      No of Contacts
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: fonts.poppins,
                        fontSize: size.label,
                        fontWeight: 600,
                      }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {buyers.map((buyer, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Avatar>{buyer.firstName[0]}</Avatar>
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {buyer.firstName} {buyer.lastName}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {buyer.email}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {buyer.phoneNumber}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {buyer.state}, {buyer.country}
                      </TableCell>
                      <TableCell sx={{ fontFamily: fonts.poppins }}>
                        {buyer.noOfContacts}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Tooltip title="Edit">
                            <Edit
                              onClick={() => handleEditBuyer(buyer)}
                              sx={{ color: colors.primary_dark }}
                            />
                          </Tooltip>
                          <Tooltip title="Purchased Plot">
                            <Visibility
                              onClick={() =>
                                handleViewPurchasedPlots(buyer._id)
                              }
                              sx={{ color: colors.primary_dark }}
                            />
                          </Tooltip>
                          <Tooltip title="Purchased Plan">
                            <CardMembership
                              onClick={() =>
                                handleViewPurchasedPlans(buyer._id)
                              }
                              sx={{ color: colors.primary_dark }}
                            />
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box>
              <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <DialogTitle
                  sx={{
                    fontFamily: fonts.poppins,
                    fontSize: size.title,
                    fontWeight: 600,
                    color: colors.primary_dark,
                  }}
                >
                  Edit No Of Contacts
                </DialogTitle>

                <DialogContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: 3,
                    }}
                  >
                    <TextField
                      type="number"
                      value={newNoOfContacts}
                      onChange={(e) => setNewNoOfContacts(e.target.value)}
                      placeholder="Enter number"
                    />
                  </Box>

                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}
                  >
                    <Button
                      onClick={handleUpdateNoOfContacts}
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundImage: colors.button,
                        fontFamily: fonts.poppins,
                      }}
                    >
                      Update
                    </Button>
                    <Button
                      onClick={() => setIsOpen(false)}
                      variant="contained"
                      size="small"
                      sx={{
                        backgroundImage: colors.button,
                        fontFamily: fonts.poppins,
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            </Box>
          </Box>
        ) : (
          <Typography
            sx={{
              fontFamily: fonts.poppins,
              fontSize: 18,
              color: colors.primary_dark,
            }}
          >
            No buyer found.
          </Typography>
        )}
      </Box>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={open}>
            <Box>
              <PurchasedPlotsPopup
                buyerId={selectedBuyerId}
                isOpen={isPopupOpen}
                onClose={() => {
                  handleClose();
                  setIsPopupOpen(false);
                  setSelectedBuyerId(null);
                }}
              />
            </Box>
          </Fade>
        </Modal>
      </div>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openplans}
          onClose={() => setOpenplans(false)}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={openplans}>
            <Box sx={{ padding: 2 }}>
              <PlanPurchaseHistoryModal
                buyerId={selectedBuyerId}
                isOpen={openplans}
                onClose={() => setOpenplans(false)}
              />
            </Box>
          </Fade>
        </Modal>
      </div>
    </Box>
  );
};

export default ListBuyers;
